var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecureCustodianshipH5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 81,
    viewBox: "0 0 160 81",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_3306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.216797H160V80.2168H0V0.216797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.99854,
    y: 76.9092,
    width: 24,
    height: 5.2,
    transform: "rotate(-60 1.99854 76.9092)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3998,
    y: 63.8164,
    width: 19.2,
    height: 5.2,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.6001,
    y: 69.0166,
    width: 16,
    height: 5.2,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3984,
    y: 74.2168,
    width: 21.2,
    height: 5.6,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.7986,
    cy: 52.617,
    r: 11.2,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9985 47.0166V58.2166",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3984 47.0166V58.2166",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9982 52.6166H31.7982C32.7924 52.6166 33.5982 51.8107 33.5982 50.8166C33.5982 49.8225 32.7924 49.0166 31.7982 49.0166H28.9982V52.6166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1982 49.0166H28.9982M28.9982 49.0166H31.7982C32.7924 49.0166 33.5982 49.8225 33.5982 50.8166V50.8166C33.5982 51.8107 32.7924 52.6166 31.7982 52.6166H28.9982V49.0166Z",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9984 52.6168H32.1984C33.1925 52.6168 33.9984 53.4227 33.9984 54.4168C33.9984 55.4109 33.1925 56.2168 32.1984 56.2168H28.9984V52.6168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1984 56.2168H28.9984M28.9984 56.2168H32.1984C33.1925 56.2168 33.9984 55.4109 33.9984 54.4168V54.4168C33.9984 53.4227 33.1925 52.6168 32.1984 52.6168H28.9984V56.2168Z",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.798 19.0166L118.798 73.4166C118.798 76.9512 115.933 79.8166 112.398 79.8166L107.598 79.8166L107.598 19.0166L118.798 19.0166Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeDasharray: "2.56 2.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5986 25.4166C35.5986 21.882 38.464 19.0166 41.9986 19.0166L107.599 19.0166L107.599 79.8166L35.5986 79.8166L35.5986 25.4166Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6001,
    y: 35.0166,
    width: 5.6,
    height: 28.8,
    rx: 2.8,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6001,
    y: 39.0166,
    width: 5.6,
    height: 3.2,
    rx: 1.6,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.6002,
    y: 56.6172,
    width: 5.6,
    height: 3.2,
    rx: 1.6,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.9998,
    cy: 49.4164,
    r: 17.6,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.0001,
    cy: 49.4166,
    r: 14.4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3984 49.417H91.5984",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9987 39.8164L81.9987 59.0164",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.9985,
    cy: 49.417,
    r: 4,
    stroke: "white",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.9985,
    cy: 49.417,
    r: 4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.065 56.8835H149.598C150.998 56.8835 152.132 58.0177 152.132 59.4168V61.9501H131.065V56.8835Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.398,
    y: 61.0166,
    width: 27.2,
    height: 19.2,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.265 67.417V66.7503H157.598H149.598C147.463 66.7503 145.732 68.4815 145.732 70.617C145.732 72.7525 147.463 74.4837 149.598 74.4837H157.598H158.265V73.817V67.417Z",
    stroke: "white",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.998,
    cy: 70.617,
    r: 1.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3984 4.61719H132.798C138.1 4.61719 142.398 8.91525 142.398 14.2172V48.6172",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeDasharray: "2.56 2.56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.399,
    cy: 47.817,
    r: 2.4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.3987,
    cy: 4.6168,
    r: 2.4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_3306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white",
    transform: "translate(0 0.216797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureCustodianshipH5);
export default __webpack_public_path__ + "static/media/secure_custodianship_h5.fec6cb49e984b6d30d89ea991ce07b14.svg";
export { ForwardRef as ReactComponent };